// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"537":"4f38d0f4c66b4898","671":"12620c0b8305047c"}[chunkId] + ".js";
};